import * as constants from '../../constants/helpers';
import callApi from '../base';

export function search(query) {
  const url = constants.API_ROOT_URL + 'search'
  return callApi(url, 'POST', { query: query })
}